import { createContext, useContext } from 'react';

export interface SourceHighlightsValue {
  /** Sources the agent just created or deployed, until the list has shown them. */
  highlightedSourceIds: readonly string[];
  clearSourceHighlight: (sourceId: string) => void;
}

const noHighlights: SourceHighlightsValue = {
  highlightedSourceIds: [],
  clearSourceHighlight: () => undefined,
};

export const SourceHighlightsContext =
  createContext<SourceHighlightsValue>(noHighlights);

export const useSourceHighlights = () => useContext(SourceHighlightsContext);
